module.exports = __webpack_public_path__ + "static/img/icon_hdrc.6865880c.png";